import { subscription, requestState } from "../actions/index";

export default (initialState, action) => {
	switch (action.type) {
		case requestState.LOADING:
			return {
				...initialState,
				loading: true,
			};

		case subscription.GET_SUBSCRIPTIONS:
			localStorage.removeItem("currentSubscription");
			localStorage.setItem("currentSubscription", action.payload.currentSubscription);
			return {
				...initialState,
				...action.payload,
				subscriptions: action.payload.subscriptions,
				loading: false,
			};

		case subscription.GET_REFERREDS:
			return {
				...initialState,
				referreds: action.payload,
				loading: false,
			};

		case subscription.CREATE_SUBSCRIPTION:
			localStorage.removeItem("user");
			localStorage.setItem("user", JSON.stringify(action.payload));
			return {
				...initialState,
				loading: false,
				success: "Subscription created successfully",
			};

		case subscription.UPDATE_SUBSCRIPTION:
			localStorage.removeItem("currentSubscription");
			localStorage.setItem("currentSubscription", action.payload);
			return {
				...initialState,
				loading: false,
				success: "Subscription updated successfully",
			};

		case subscription.CANCEL_SUBSCRIPTION:
			localStorage.removeItem("user");
			localStorage.setItem("user", JSON.stringify(action.payload));
			return {
				...initialState,
				loading: false,
				success: "Subscription cancelled successfully",
			};

		case subscription.CHECK_SUBSCRIPTION:
			return {
				...initialState,
				loading: false,
				isValid: action.payload,
			};
		case subscription.GET_GATEWAY:
			return {
				...initialState,
				loading: false,
				gateways: action.payload,
			};
		case subscription.CLEAR_GATEWAY:
			return {
				...initialState,
				gateways: null
			};
		case subscription.FINALIZE_TRANSACTION:
			localStorage.removeItem("user");
			localStorage.setItem("user", JSON.stringify(action.payload));
			return {
				...initialState,
				loading: false,
				success: `Successful transaction`,
			};
		case requestState.ERROR:
			return {
				...initialState,
				error: action.payload,
				loading: false,
			};

		case requestState.CLEAR_NOTIFICATION:
			return {
				...initialState,
				error: null,
				success: null,
			};
		default:
			return initialState;
	}
};
